<template>
    <section
        class="flex w-3/5"
        :class="{ 'bg-yellow-50 w-full': full != 'undefined' }"
    >
        <div
            class="
                h-full
                divide-y divide-gray-200
                flex flex-col
                bg-white
                shadow-xl
                min-h-full
                list
            "
            :class="{ ' w-full': full != 'undefined' }"
        >
            <div class="flex-1 flex flex-col py-6 space-y-6 overflow-y-scroll">
                <header class="px-4 sm:px-6">
                    <div class="flex items-start justify-between space-x-3">
                        <h2
                            class="
                                text-lg
                                leading-7
                                font-medium
                                text-gray-900
                                relative
                            "
                        >
                            <svg
                                v-if="isVoting"
                                class="animate-spin h-5 w-5 mt-1 absolute"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    class="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    stroke-width="4"
                                ></circle>
                                <path
                                    class="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                            </svg>
                            <span
                                class="transition ease-in-out duration-300"
                                :class="{ 'ml-7': isVoting }"
                            >
                                {{ t("tts.polls.naming") }}
                            </span>
                        </h2>

                        <div
                            class="h-7 flex items-center"
                            v-if="can_initiate == true"
                        >
                            <button
                                @click="newPoll = true"
                                class="
                                    cursor-pointer
                                    inline-flex
                                    justify-center
                                    py-2
                                    px-4
                                    border border-transparent
                                    text-sm
                                    leading-5
                                    font-medium
                                    rounded-md
                                    text-white
                                    bg-blue-600
                                    hover:bg-blue-500
                                    focus:outline-none
                                    focus:border-blue-700
                                    focus:shadow-outline-blue
                                    active:bg-blue-700
                                    transition
                                    duration-150
                                    ease-in-out
                                    tts-button
                                "
                            >
                                {{ t("tts.polls.init") }}
                            </button>
                        </div>
                    </div>
                </header>

                <div class="relative flex-1 px-4 sm:px-6">
                    <svg
                        v-if="!polls"
                        class="
                            flex
                            animate-spin
                            h-6
                            w-6
                            mt-5
                            text-gray
                            items-center
                            mb-6
                        "
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"
                        />
                        <path
                            class="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                    </svg>

                    <div
                        class="bg-gray-100 shadow rounded-lg mb-6 relative"
                        v-for="(poll, index) in polls"
                        v-bind:key="index"
                    >
                        <div class="p-2 px-4">
                            {{ poll.question }}
                        </div>
                        <div class="bg-gray-50 p-2 px-4">
                            <div
                                class="answer"
                                v-for="(answer, subindex) in poll.results"
                                v-bind:key="subindex"
                            >
                                <span class="font-semibold">
                                    <svg
                                        v-if="
                                            poll.has_voted == answer['answer']
                                        "
                                        class="w-4 h-4 inline-block font-light"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                        ></path>
                                    </svg>

                                    {{ answer["answer"] }}
                                    <span
                                        v-if="
                                            poll.is_published ||
                                            can_initiate == true
                                        "
                                    >
                                        <span
                                            class="text-xs text-gray-500"
                                            v-if="
                                                answer['weight'] != 'private' ||
                                                can_initiate == true
                                            "
                                        >
                                            &bull; {{ answer["percentage"] }}%
                                            &bull; {{ answer["weight"] }}
                                            {{ t("tts.polls.weight") }} &bull;
                                            {{ answer["votes"] }}
                                            {{ t("tts.polls.votes") }}
                                        </span>
                                    </span>
                                </span>
                                <div
                                    class="relative pt-1"
                                    v-if="
                                        poll.is_published ||
                                        can_initiate == true
                                    "
                                >
                                    <div
                                        class="
                                            overflow-hidden
                                            h-2
                                            mb-4
                                            text-xs
                                            flex
                                            rounded
                                            bg-blue-200
                                            poll-empty
                                        "
                                    >
                                        <div
                                            :style="
                                                'width:' +
                                                answer['percentage'] +
                                                '%'
                                            "
                                            class="
                                                shadow-none
                                                flex flex-col
                                                text-center
                                                whitespace-nowrap
                                                text-white
                                                justify-center
                                                bg-blue-600
                                                poll-fill
                                            "
                                        ></div>
                                    </div>
                                </div>
                            </div>
                            <span
                                class="
                                    inline-flex
                                    rounded-md
                                    shadow-sm
                                    mb-2
                                    mr-2
                                "
                                v-if="!poll.is_closed && can_initiate == true"
                            >
                                <button
                                    @click="closePoll(poll)"
                                    type="button"
                                    class="
                                        inline-flex
                                        items-center
                                        px-2.5
                                        py-1.5
                                        border border-transparent
                                        text-xs
                                        leading-4
                                        font-medium
                                        rounded
                                        text-white
                                        bg-red-600
                                        hover:bg-red-500
                                        focus:outline-none
                                        focus:red-blue-700
                                        focus:shadow-outline-red
                                        active:bg-red-700
                                        transition
                                        ease-in-out
                                        duration-150
                                    "
                                >
                                    {{ t("tts.polls.stop") }}
                                </button>
                            </span>
                            <span
                                class="
                                    inline-flex
                                    rounded-md
                                    shadow-sm
                                    mb-2
                                    mr-2
                                "
                                v-if="
                                    !poll.is_published && can_initiate == true
                                "
                            >
                                <button
                                    @click="publishPoll(poll)"
                                    type="button"
                                    class="
                                        inline-flex
                                        items-center
                                        px-2.5
                                        py-1.5
                                        border border-transparent
                                        text-xs
                                        leading-4
                                        font-medium
                                        rounded
                                        text-white
                                        bg-gray-600
                                        hover:bg-gray-500
                                        focus:outline-none
                                        focus:text-gray-700
                                        focus:shadow-outline-red
                                        active:bg-gray-700
                                        transition
                                        ease-in-out
                                        duration-150
                                    "
                                >
                                    {{
                                        t(
                                            "tts.polls.publish",
                                            "Publiceer stemming"
                                        )
                                    }}
                                </button>
                            </span>
                            <span
                                class="inline-flex rounded-md shadow-sm mb-2"
                                v-if="
                                    !poll.is_closed &&
                                    !poll.has_voted &&
                                    can_initiate != true
                                "
                            >
                                <button
                                    @click="doVote(poll)"
                                    type="button"
                                    class="
                                        capitalize
                                        inline-flex
                                        items-center
                                        px-2.5
                                        py-1.5
                                        border border-transparent
                                        text-xs
                                        leading-4
                                        font-medium
                                        rounded
                                        text-white
                                        bg-indigo-600
                                        hover:bg-indigo-500
                                        focus:outline-none
                                        focus:indigo-blue-700
                                        focus:shadow-outline-indigo
                                        active:bg-indigo-700
                                        transition
                                        ease-in-out
                                        duration-150
                                        tts-button
                                    "
                                >
                                    {{ t("tts.polls.vote") }}
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <new-poll
            v-if="newPoll && can_initiate == true"
            :workshop="workshop"
            :talk_id="talk_id"
            :room="room"
            @hide="newPoll = false"
        ></new-poll>
    </section>
</template>
<script>
import Swal from "sweetalert2";
export default {
    mounted() {
        let self = this;
        Eventing.listen("reloadPolls", () => this.getPolls());
        this.getPolls();
        try {
            if (
                document.head.querySelector('meta[name="is_moderator"]')
                    .content == "true"
            ) {
                this.can_initiate = true;
            }
        } catch (error) {}
    },
    created() {
        let self = this;
        const debouncedFunction = _.debounce(() => {
            this.getPolls();
        }, 400);
        Echo.private("answers." + self.pusher).listen(".new-answer", (e) => {
            if (self.can_initiate) {
                self.isVoting = true;
                debouncedFunction();
            }
        });
        Echo.private("polls." + self.pusher).listen(".new-poll", (e) => {
            // this.poll = null;
            self.getPolls();
        });
        Echo.private("polls." + this.pusher)
            .listen(".stop-poll", (e) => {
                this.poll = null;
                self.getPolls();
            })
            .listen(".new-poll", (e) => {
                self.getPolls();
            });
    },
    props: ["talk_id", "room", "workshop", "pusher", "full"],
    data() {
        return {
            newPoll: false,
            polls: null,
            can_initiate: false,
            isVoting: false,
        };
    },
    methods: {
        doVote(poll) {
            poll.has_voted = true;
            Eventing.fire("revotePoll", poll);
        },
        getPolls() {
            var self = this;
            var url = "/api/polls?results=true";
            if (this.workshop && this.workshop != "undefined") {
                url = url + "&workshop=" + this.workshop;
            }
            if (this.room && this.room != "undefined") {
                url = url + "&room=" + this.room;
            }
            axios.get(url).then((response) => {
                self.polls = response.data;
                self.isVoting = false;
            });
        },
        closePoll(poll) {
            var self = this;
            Swal.fire({
                title: "",
                text: self.t("tts.polls.stop-poll-confirm"),
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    axios.delete("/api/polls/" + poll.id).then((response) => {
                        // self.polls = response.data;
                        poll.is_closed = true;
                        // console.info(response.data);
                    });
                }
            });
        },
        publishPoll(poll) {
            var self = this;
            Swal.fire({
                title: "",
                text: self.t("tts.polls.publish", "Stemming publiceren?"),
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    axios
                        .delete("/api/polls/" + poll.id + "?publish=true", {
                            publish: true,
                        })
                        .then((response) => {
                            // self.polls = response.data;
                            poll.is_published = true;
                            // console.info(response.data);
                        });
                }
            });
        },
    },
};
</script>
